<template>
    <v-navigation-drawer
      v-model="visible"
      app
      fixed
      temporary
    >
      <div class="filter-menu-box">
        <article-filter @filtersUpdate="filtersUpdate" class="mobile-filter" ref="articleFilter" />
      </div>
    </v-navigation-drawer>
</template>

<style scoped>
  @import '../../assets/styles/global-styles.css';
  @import '../../assets/styles/variables.css';

  .nav-box {
    max-height: 100%;
  }

  .menu-list {
    overflow-y: scroll;
    min-height: 100vh;
  }

  .filter-menu-box {
    max-height: 100%;
    min-height: 100%;
  }

  .mobile-filter {
    padding-bottom: 100px;
  }
</style>


<script lang="ts">
  import { ArticleFiltersDto } from '@/interfaces/ArticleFiltersDto';
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import ArticleFilter from './ArticleFilter.component.vue';

  const rubricType = 1;
  const classType = 2;

  /**
   * @desc boite d'outils en navigation drawer pour l'affichage mobile des filtres
   */
  @Component({
    components: {
      'article-filter' : ArticleFilter
    },
  })
  export default class MobileArticleFilter extends Vue {
    visible = false;

    @Prop()
    menuVisible? : boolean;

    /**
     * @desc affiche la boite de navigation
     */
    @Watch('menuVisible')
    showMenu() : void {
      this.visible = false;
      setTimeout(() => {
        this.visible = true;
        (this.$refs.articleFilter as any).updateArticles();
      }, 10);
    }

    public filtersUpdate(filteringData?: ArticleFiltersDto): void {
        this.$root.$emit('filtersUpdate', filteringData);
    }
  }

</script>
